import styled from '@emotion/styled';

import { useCapabilityValue } from '../../store/devices/useCapabilityValue';

import { round } from '../../lib/math';
import { getThermostatColor } from '../../lib/capabilities/thermostat';
import { theme } from '../../theme/theme';

export function IndicatorThermostat({ device }) {
  const [measureTemperatureValue] = useCapabilityValue({
    deviceId: device.id,
    capabilityId: 'measure_temperature',
  });
  const [targetTemperatureValue] = useCapabilityValue({
    deviceId: device.id,
    capabilityId: 'target_temperature',
  });
  const [thermostatModeValue] = useCapabilityValue({
    deviceId: device.id,
    capabilityId: 'thermostat_mode',
  });

  const color = getThermostatColor({
    mode: thermostatModeValue,
    measure: measureTemperatureValue,
    target: targetTemperatureValue,
  });

  return (
    <sc.container color={color}>
      <sc.text>
        {targetTemperatureValue != null
          ? round(targetTemperatureValue, 1)
              .toString()
              .split('.')
              .map((part, index) => {
                if (index > 0) return <sc.sup key={index}>{part}</sc.sup>;

                return part;
              })
          : '-'}
      </sc.text>
    </sc.container>
  );
}

const sc = {
  container: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: ${(props) => props.color};
    box-shadow: 0 0 1px 1px ${(props) => props.color};
    font-size: ${theme.fontSize.small};
    font-weight: ${theme.fontWeight.bold};
  `,
  text: styled.div`
    color: ${theme.color.text_white};
  `,
  sup: styled.sup`
    font-size: 8px;
  `,
};
